<template src="./index.html">
</template>
<script>
import {getdata} from './data.js'
import iinv from './iinv/index.vue'
import requisitionDetail from './requisitionDetail/index.vue'

export default {
  components: {
    iinv, requisitionDetail
  },
  data: function () {
    return {
      headlist: getdata().headlist,
      chooseindex: 0
    };
  },
  created() {
  },
  methods: {
    forchooseindex(e) {
      this.chooseindex = e
    }
  }
};
</script>
<style scoped lang="less">
@import url("./index.less");
</style>
